import { render, staticRenderFns } from "./StatusValue.vue?vue&type=template&id=06523c64&scoped=true"
import script from "./StatusValue.vue?vue&type=script&lang=js"
export * from "./StatusValue.vue?vue&type=script&lang=js"
import style0 from "./StatusValue.vue?vue&type=style&index=0&id=06523c64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06523c64",
  null
  
)

export default component.exports